var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitzpatrickLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FitzpatrickAdvisory",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.06 91.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58 77.08 58 91.11 72 91.11 72 77.08 86.06 77.08 86.06 65.17 72.06 65.17 72.06 0 0 0 0 91 12.94 91 12.94 14.06 58 14.06 58 65.17 49 65.17 49 21.94 39.11 21.94 39.11 65.17 29.78 65.17 29.78 21.94 19.11 21.94 19.11 77.22 58 77.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitzpatrickLogo);
export default __webpack_public_path__ + "static/media/fitzpatrick-logo.835376c20d14b5935b162539525a0135.svg";
export { ForwardRef as ReactComponent };